import { ListSubheader, Stack, SxProps, Theme } from '@mui/material';
import React from 'react';
import { Box } from 'src/components/Box';
import { ListItem } from 'src/components/ListItem';
import { SearchTextField } from 'src/components/SearchTextField';

// Define icon type for FontAwesome icons
type IconDefinition = any;

export interface SectionItem {
  label: string;
  icon?: IconDefinition;
  iconColor?:
    | 'primary'
    | 'secondary'
    | 'inherit'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  onClick: () => void;
  disabled?: boolean;
  selected?: boolean;
}

export interface Section {
  title: string;
  items: SectionItem[];
}

export interface SectionedItemSelectorProps {
  searchValue: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  sections: Section[];
  sx?: SxProps<Theme>;
  additionalContent?: React.ReactNode;
}

export const SectionedItemSelector: React.FC<SectionedItemSelectorProps> = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  sections,
  sx,
  additionalContent,
}) => {
  return (
    <Box sx={sx}>
      {onSearchChange && (
        <SearchTextField
          placeholder={searchPlaceholder}
          value={searchValue}
          onSearch={onSearchChange}
          onCancel={() => onSearchChange('')}
        />
      )}
      <Stack spacing={1}>
        {sections.map((section, sectionIndex) => (
          <React.Fragment key={sectionIndex}>
            <ListSubheader sx={{ bgcolor: 'transparent', mt: 2 }}>
              {section.title}
            </ListSubheader>
            {section.items.map((item, itemIndex) => (
              <ListItem
                key={itemIndex}
                icon={item.icon}
                primary={item.label}
                iconColor={item.iconColor}
                onClick={item.onClick}
                disabled={item.disabled}
                selected={item.selected}
                rounded
                clickable
              />
            ))}
          </React.Fragment>
        ))}
      </Stack>
      {additionalContent}
    </Box>
  );
};
